import * as React from 'react'
import { cn } from '../../lib/utils'

export interface RadioCardProps extends React.HTMLAttributes<HTMLDivElement> {
	title: string
	description?: string
	selected?: boolean
}

const RadioCard = React.forwardRef<HTMLDivElement, RadioCardProps>(
	({ className, title, description, selected = false, ...props }, ref) => (
		<div
			ref={ref}
			role="radio"
			aria-checked={selected}
			tabIndex={0}
			className={cn(
				'flex gap-2 items-start p-3 rounded-(--radius) border border-(--color-border) cursor-pointer',
				className,
			)}
			{...props}
		>
			{/* Radio indicator */}
			<div className="relative shrink-0 size-4 mt-px">
				<div className="size-4 rounded-full border border-(--color-muted-foreground) bg-(--color-background)" />
				{selected && (
					<div className="absolute top-[3px] left-[3px] size-[10px] rounded-full bg-(--color-foreground)" />
				)}
			</div>

			{/* Content */}
			<div className="flex flex-col gap-1 flex-1 min-w-0 text-sm">
				<p className="font-medium leading-none text-(--color-foreground)">
					{title}
				</p>
				{description && (
					<p className="font-normal leading-5 text-(--color-muted-foreground)">
						{description}
					</p>
				)}
			</div>
		</div>
	),
)
RadioCard.displayName = 'RadioCard'

export { RadioCard }
